import React from 'react';
import { EyeIcon, GraduationCapIcon, LayoutListIcon, PrinterIcon, WrenchIcon } from 'lucide-react';
import { differentiators } from '../data/content';
const ICONS = [WrenchIcon, EyeIcon, LayoutListIcon, PrinterIcon, GraduationCapIcon];
export function NotAnEbook() {
  return <section className="w-full bg-slate-950 px-5 py-12 text-white sm:py-14" data-id="element-137" data-mp="3qhkn0o1erobh">
      <div className="mx-auto max-w-[940px] text-center" data-id="element-138" data-mp="3qfgflw4aw76g">
        <h2 className="text-balance text-[1.5rem] font-extrabold uppercase leading-[0.95] tracking-tight sm:text-[1.9rem]" data-id="element-139" data-mp="3mgh41so2dc61">
          This Is NOT Another Financial Literacy Ebook
        </h2>
        <p className="mt-2 text-[1.25rem] font-extrabold uppercase leading-[0.95] tracking-tight text-orange-500 sm:text-[1.6rem]" data-id="element-140" data-mp="3cib3pfhwoe3a">
          It’s a Complete Ready-to-Teach System
        </p>

        <dl className="mx-auto mt-7 grid gap-3 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-141" data-mp="1ap3rwg1i4em5">
          {differentiators.map((item, index) => {
          const Icon = ICONS[index % ICONS.length];
          return <div key={item.title} className="rounded-md bg-slate-900 px-5 py-4" data-id="element-142" data-mp="3n1vzftfr943t" data-mpi={index}>
                <dt className="flex items-center gap-2 text-[1rem] font-extrabold uppercase leading-tight tracking-tight text-orange-500 sm:text-[1.05rem]" data-id="element-143" data-mp="3s3lerla0g3xp">
                  <Icon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-144" data-mp="3i4e10wzd67a2" />
                  {item.title}
                </dt>
                {item.description.map(line => <dd key={line} className="mt-1.5 text-[0.95rem] leading-snug text-white/90" data-id="element-145" data-mp="9qnh5l0oxn6p">
                    {line}
                  </dd>)}
              </div>;
        })}
        </dl>

        <p className="mt-7 text-balance text-[1rem] font-extrabold uppercase leading-tight tracking-tight text-white sm:text-[1.15rem]" data-id="element-146" data-mp="4w9k7e6dr7zx">
          Less searching. Less preparation. Less improvising. More lessons
          already solved.
        </p>
      </div>
    </section>;
}